import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

const CopyButton = ({ copyElements }) => {
	return (
		<>
			{copyElements.every((element) => {
				return element ? true : false;
			}) ? (
				//An if is used here because MUI throws an error if a tooltip is applied to a disabled button
				<Tooltip title="Copy Selected Head and Shaft Tags">
					<Button
						variant="contained"
						onClick={() => {
							//This code is needed because the site is currently on HTTP.
							//Should be changed to use navigator.clipboard.writeText when switched to HTTPS
							const el = document.createElement("textarea");
							let copyText = "";
							copyElements.forEach((element, index) => {
								if (index === 0) {
									copyText = element.name;
								} else {
									copyText += "," + element.name;
								}
							});
							el.value = copyText;
							el.setAttribute("readonly", "");
							el.style.position = "absolute";
							el.style.left = "-9999px";
							document.body.appendChild(el);
							el.select();
							document.execCommand("copy");
							document.body.removeChild(el);
						}}
					>
						{copyElements.length > 1 ? "Copy Tags" : "Copy Tag"}
					</Button>
				</Tooltip>
			) : (
				<Button variant="contained" disabled={true}>
					{copyElements.length > 1 ? "Copy Tags" : "Copy Tag"}
				</Button>
			)}
		</>
	);
};

export default CopyButton;
